export const setFilterTextActionType = 'setFilterTextActionType';

export function setFilterTextAction(text) {
    return {
        type: setFilterTextActionType,
        payload: {
            text: text,
        }
    }
}

export function setFilterTextHandler(state, action) {
    const { text } = action.payload;
    return {...state, filterText: text, directoryContentTargetItemIndexes: new Map(), predictedSelectedFileSystemNodeType: 'directory', selectedFileSystemNodePath: []};
}
